import {DecimalSource} from '../break_infinity.js';

export type DynamicValue = (step: number, optionIndex: number) => DecimalSource;

export type DynamicCost = Map<
  string,
  {value: DynamicValue; string?: DynamicValue}
>;

export type Cost = Map<string, {value: DecimalSource; string?: DecimalSource}>;

export function evaluateCost(
  cost: DynamicCost,
  step: number,
  optionIndex: number
): Cost {
  return new Map(
    [...cost].map(([key, {value, string}]) => [
      key,
      {value: value(step, optionIndex), string: string?.(step, optionIndex)},
    ])
  );
}
